import React from'react';
import { render } from 'react-dom';
import "./VCButton.sass"

export interface btnContent {
    copy: string;
    route: string;
    key: string;
}

interface Props{
   contents: btnContent,
   setActive(key:string): void,
    active: string,
    btnCls?:string
}
type Active = {active:string}

class VCButton extends React.Component<Props, Active>  {
    constructor(props:Props){
        super(props);             
    }   

    render(){
        let activeClass = this.props.active === this.props.contents.key?"active":"";
        return(
            <button type="button"  className={`vc-button ${activeClass} ${this.props.btnCls}`} key={this.props.contents.key} onClick={()=>this.props.setActive(this.props.contents.key)}>{this.props.contents.copy}</button>
        )
    }
}
export default VCButton;
